export enum FilterGroupEnum {
    rfrOrdHeatingType = 'rfrOrdHeatingType',
    rfrOrdType = 'rfrOrdType',
    rfrOrdOnLocation = 'rfrOrdOnLocation',
    rfrOrdDisconnected = 'rfrOrdDisconnected',
}
